var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.typeName)?_c('SIcon',{staticClass:"data-type-icon",attrs:{"name":`data-type-${_vm.typeName}`,"height":_vm.size,"width":_vm.size}}):_c('SIcon',{staticClass:"data-type-icon",attrs:{"name":`data-type-${_vm.dataType}`,"height":_vm.size,"width":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }